import {Component, Input, OnInit, Output, EventEmitter} from '@angular/core';
import {Package} from "../../../model/package";
import {ProductService} from "../../../service/product.service";

@Component({
  selector: 'app-package',
  templateUrl: './package.component.html',
  styleUrls: ['./package.component.css']
})
export class PackageComponent implements OnInit {

  displayInfo: boolean = false;


  constructor(private productService: ProductService) {
  }

  @Output() infoRequest = new EventEmitter();
  @Output() selectEvent = new EventEmitter();
  @Input() package: Package;
  @Input() hasAdditional = '';

  hasDocument: string;

  ngOnInit(): void {

  }

  getLongName(shortName) {
    let result;
    this.productService.getProducts().subscribe(products => {
      products.forEach(product => {
          if (product.nameShort === shortName)
            result = product.name_long.substr(0, 26);
          return;
        });
      }
    )
    ;


    return result ? result : shortName;
  }


  displayInfoMessage() {
    this.displayInfo = true;
  }

}
